<template>
<div class="special-data-manage bgc box-shadow">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="用户管理" name="userManage">
            <el-scrollbar class="tab-item-scroll">
                <UserManage ref="userManage"></UserManage>
            </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="订单管理" name="orderManage">
            <el-scrollbar class="tab-item-scroll">
                <OrderManage ref="orderManage"></OrderManage>
            </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="做题管理" name="specialExamMgt">
            <el-scrollbar class="tab-item-scroll">
                <specialExamMgt ref="specialExamMgt"></specialExamMgt>
            </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="数据分析" name="specialAnalysisMgt">
            <el-scrollbar class="tab-item-scroll">
                <specialAnalysisMgt ref="specialAnalysisMgt"></specialAnalysisMgt>
            </el-scrollbar>
        </el-tab-pane>
    </el-tabs>
    <div class="return-exam-list" @click="handleReturnExamList">返回考试列表</div>
</div>
</template>
<script>
import UserManage from './components/dataManage/userManage.vue'
import OrderManage from './components/dataManage/orderManage.vue'
import SpecialExamMgt from './components/specialExamMgt.vue'
import SpecialAnalysisMgt from './components/specialAnalysisMgt.vue'
import SpecialBank from '@/common/js/specialBank.json'
export default {
    data() {
        return {
            activeName: 'userManage',
            params: {
                examcode: '',
                examname: ''
            }
        }
    },
    created() {
        if (this.$route.query.examcode) {
            this.params.examcode = this.$route.query.examcode
            this.params.examname = SpecialBank[this.$route.query.examcode].examname
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs[this.activeName].initData(this.params)
        })
    },
    methods: {
        handleClick() {
            switch (this.activeName) {
                case 'userManage':
                    this.$refs.userManage.initData(this.params)
                    break
                case 'orderManage':
                    this.$refs.orderManage.initData(this.params)
                    break
                case 'specialExamMgt':
                    this.$refs.specialExamMgt.initData(this.params)
                    break
                case 'specialAnalysisMgt':
                    this.$refs.specialAnalysisMgt.initData(this.params)
                    break
            }
        },
        handleReturnExamList() {
            this.$router.go(-1)
        },
    },
    components: {
        UserManage,
        OrderManage,
        SpecialExamMgt,
        SpecialAnalysisMgt
    }
}
</script>
<style lang="scss">
.special-data-manage {
    position: relative;
    height: calc(100vh - 50px - 40px);
    box-sizing: border-box;
    padding: 20px 0;
    .return-exam-list {
        color: #409EFF;
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 20px;
        line-height: 40px;
    }
    .el-tabs {
        height: 100%;
        .el-tabs__header {
            margin-bottom: 20px;
            margin-right: 20px;
            margin-left: 20px;
        }
        .el-tabs__content {
            height: calc(100% - 60px);
            .el-tab-pane {
                height: 100%;
                .tab-item-scroll {
                    height: 100%;
                    .el-scrollbar__wrap {
                        overflow-x: hidden;
                        .el-scrollbar__view {
                            padding: 0 20px;
                        }
                    }
                    .is-vertical {
                        min-width: 6px !important;
                    }
                }
            }
        }
    }
    .filters {
        .el-input,.el-input input {
            width: 150px;
            height: 32px;
        }
        .el-select .el-input,.el-select .el-input input {
            width: 108px;
            height: 32px;
        }
        .el-range-editor.el-input__inner input{
            width: 80px;
        }
        .el-range-editor.el-input__inner{
            width: 220px;
        }
        .el-range-separator{
            line-height: 24px;
        }
    }

    .imageText{
        display: flex;
        .img{
            width: 60px;
            height: 60px;
            min-width: 60px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .tc{
        .cell{
            text-align: center;
        }
    }
    .filters{
        margin-bottom: 15px;
    }
}
</style>